import * as React from 'react';

import iconUrl from './TopArrowIcon.svg';

export const TopArrowIcon = <img width="10" height="10" src={iconUrl} alt="" />;
